import { Controller } from "@hotwired/stimulus"

/**
 * Client Edit Controller
 *
 * Handles opening the edit client modal and populating form fields
 * with client data. Works with Bootstrap modal API.
 *
 * Usage:
 *   <a href="#"
 *      data-controller="client-edit"
 *      data-client-edit-id-value="<%= client.id %>"
 *      data-client-edit-name-value="<%= client.name %>"
 *      data-client-edit-url-value="<%= client_path(client) %>"
 *      data-action="click->client-edit#open">
 *     Edit
 *   </a>
 */
export default class extends Controller {
  static values = {
    id: Number,
    name: String,
    url: String
  }

  /**
   * Open the edit modal and populate form fields
   *
   * @param {Event} event - Click event
   */
  open(event) {
    event.preventDefault()

    // Get the modal element
    const modalElement = document.getElementById('edit-client')
    if (!modalElement) {
      console.error('Edit client modal not found')
      return
    }

    // Get the form element
    const form = document.getElementById('edit-client-form')
    if (!form) {
      console.error('Edit client form not found')
      return
    }

    // Update form action URL
    form.action = this.urlValue

    // Populate form fields
    const idField = form.querySelector('#client_id')
    const nameField = form.querySelector('#client_name')

    if (idField) {
      idField.value = this.idValue
    }

    if (nameField) {
      nameField.value = this.nameValue
    }

    // Open the modal using Bootstrap's modal API
    const modal = new bootstrap.Modal(modalElement)
    modal.show()
  }
}
